import { getDefaultAxios } from "./DefaultAxios";

export default class RequestBase {
    defaultAxios : any;
    constructor(url){
        this.defaultAxios = getDefaultAxios(url);
    }

    GetAll(onSuccess){
        this.defaultAxios.get("")
        .then((res) => 
        {
            onSuccess(res.data);
        });
    }

    Get(id, onSuccess){
        this.defaultAxios.get(`/${id}`)
        .then((res) => 
        {
            onSuccess(res.data);
        });
    }

    Add(data, onSuccess){
        this.defaultAxios.post("", data)
        .then((res) => 
        {
            onSuccess(res.data);
        });
    }

    Edit(data, onSuccess){
        this.defaultAxios.patch("", data)
        .then((res) => 
        {
            onSuccess(res.data);
        });
    }

    Delete(id, onSuccess){
        this.defaultAxios.delete(`/${id}`)
        .then((res) => 
        {
            onSuccess(res.data);
        });
    }
}